module.exports = __webpack_public_path__ + "static/media/slide1.d9da8e5a.jpg";